import useHours from '../../../hooks/use-hours'
import useDurations from '../../../hooks/use-durations'
import { find, get } from 'lodash'
import moment from 'moment'

const useCourseDiscussionTopic = ({
    course = {},
    maxName = 20
}) => {
    const [ hours ] = useHours()
    const [ durations ] = useDurations()
    const hour = find(hours, { id: course.hourId })
    const hourText = hour ? hour.name : ''
    const duration = find(durations, { id: course.durationId })
    const durationText = duration ? duration.name : ''
    const date = moment(course.date).format('M/D/YY')
    const name = get(course, 'name', '')
    const nameText = name.length > maxName ? `${name.substring(0, maxName)}...` : name
    const topic = `${date} - ${hourText}/${durationText} - ${nameText}`
    return {topic}
}

export default useCourseDiscussionTopic
